<div [ngClass]="{'clickable': clickable}">
  <p
    class="counter"
    data-cy="number-presenter--number"
    [ngClass]="{'main-number': mainNumber}"
  >{{number ? number : '-'}}</p>
  <p class="number-counter-label">{{label}}</p>
</div>
